import { render, staticRenderFns } from "./Create-Customer.vue?vue&type=template&id=3c5ef406&scoped=true"
import script from "./Create-Customer.vue?vue&type=script&lang=js"
export * from "./Create-Customer.vue?vue&type=script&lang=js"
import style0 from "./Create-Customer.vue?vue&type=style&index=0&id=3c5ef406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5ef406",
  null
  
)

export default component.exports